export const environment = {
    env: 'prod',
    production: true,
    APP_VERSION: '3.6.5',
    ADMIN_VERSION: '3.6.5',
    API_URL: '/api',
    APP_URL: 'https://app.cosmosengineering.es',
    ADMIN_URL: 'https://admin.cosmosengineering.es',
    POSTHOG_API_KEY: 'phc_2MYK19WxxeSXFSbgsehqW3Ci3Zf2Kk6KJYeYwjiNjwr',
    POSTHOG_HOST: 'https://eu.i.posthog.com'
};
